module.exports = __webpack_public_path__ + "static/media/effect_anim_645_rotate.e51dea0d.wav";